var React = require('react');

var liHeight = 42 + 6;

var Playlist = React.createClass({

  handlePlayNow: function(e){
    var pos = +e.currentTarget.attributes['data-pos'].value;
    this.props.handlePlayNow(pos, this.props.playlist[pos]);
    return false;
  },

  render: function(){
    this.playlistCount = this.props.playlist.length;

    this.playlistElements = this.props.playlist.map(function(video, i){
      var key = video.videoId + '_' + i;
      var classNames = (i < this.props.position) ? 'old' :
        (i === this.props.position) ? 'active' : 'queued';

      var ico = ((i === this.props.position) && this.props.playing) ?
        <i className="fa fa-pause" /> :
        <i className="fa fa-play" />;

      return (
        <li onClick={this.handlePlayNow} className={classNames} data-pos={i} key={key}>
          {ico}
          <span>{video.snippet.title}</span>
        </li>
      );
    }, this);

    return (
      <ul className="playlist" ref="playlist">
        {this.playlistElements}
      </ul>
    )
  }
});

module.exports = Playlist;
